import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import {
    ShFormPasswordComponent,
    ShFormTextInputComponent,
    ShLoadingComponent,
    ShNotificationComponent
} from '@stylehaven/components';
import { LoadingModule } from '../loading/loading.module';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginContainerComponent } from './containers/login-container/login-container.component';
import { LogoutContainerComponent } from './containers/logout-container/logout-container.component';
import { OauthRedirectContainerComponent } from './containers/oauth-redirect/oauth-redirect-container.component';

@NgModule({
    declarations: [LoginContainerComponent, LogoutContainerComponent, OauthRedirectContainerComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        LoadingModule,
        AuthenticationRoutingModule,
        TranslateModule.forChild({ extend: true }),
        ShLoadingComponent,
        ShNotificationComponent,
        ShFormTextInputComponent,
        ShFormPasswordComponent
    ]
})
export class AuthenticationModule {}
